export default function handleChange(state={},setState=()=>{}) {
   
   return (evt)=>{
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value
    });
   } 
}